import { render } from "./NewDonorInformationForm.vue?vue&type=template&id=e516b208"
import script from "./NewDonorInformationForm.vue?vue&type=script&lang=js"
export * from "./NewDonorInformationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__